import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['username']

  registerUsername() {
    // TODO: Validate if the 'username' is available
  }
}